module.exports = __webpack_public_path__ + "img/14e-doc-acao-comentar.e0edc874.png";